module.exports = __webpack_public_path__ + "static/media/Foodcourt-1.46a84eff.webp";